module.exports = __webpack_public_path__ + "img/25.7564e6ab.png";